// ProductForm.js
import { useForm, Controller } from "react-hook-form";
import {
  Box,
  TextField,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  Alert,
} from "@mui/material";
import { addStock } from "../utils/api";
import { useState } from "react";

const ProductForm = ({
  product,
  done,
  setSnackbarMessage,
  setSnackbarSeverity,
  handleOpenSnackbar,
}) => {
  const { handleSubmit, control, reset } = useForm();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const onSubmit = async (data) => {
    try {
      setIsButtonDisabled(true);
      if (product) {
        data.pd = product._id;
        const response = await addStock(data);
        if (response.status === 201) {
          setSnackbarMessage(response.data.message || "Successful");
          setSnackbarSeverity("success");
          handleOpenSnackbar();
          reset();
          done();
        } else {
          setSnackbarMessage(response.data.message || "Failed");
          setSnackbarSeverity("error");
          handleOpenSnackbar();
        }
      }
    } catch (error) {
      console.error("Error:", error);
      setSnackbarMessage(
        error?.response?.data?.message ||
          "An error occurred. Please try again later."
      );
      setSnackbarSeverity("error");
      handleOpenSnackbar();
    }
  };

  return (
    <>
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          maxWidth: 400,
        }}
      >
        <Alert severity="info" variant="outlined">
          Note:
          <br />
          If you need to deduct stock, enter a negative value.
          <br />
          Example: -10
        </Alert>
        <Controller
          name="qty"
          control={control}
          defaultValue=""
          rules={{
            required: "Quantity is required",
            validate: (value) => {
              const numberValue = parseFloat(value);

              if (numberValue === 0) {
                return "Quantity cannot be 0";
              }

              if (numberValue > 5000) {
                return "Quantity must not exceed 5000";
              }

              if (!Number.isInteger(numberValue)) {
                return "Quantity must be a whole number";
              }

              if (numberValue < 0 && Math.abs(numberValue) > product?.stocks) {
                return (
                  "Cannot deduct more than available stock: " + product?.stocks
                );
              }

              return true;
            },
          }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              size="small"
              {...field}
              label="Quantity"
              type="number"
              fullWidth
              error={!!error}
              helperText={error ? error.message : null}
              autoComplete="off"
            />
          )}
        />
        <Box textAlign="right">
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={isButtonDisabled}
          >
            Save
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default ProductForm;
